import { isProd, isStg } from "@/env";

type SucceedLoginEnvironment = "dev" | "stg" | "prod";

export const DEFAULT_SCHOOL_AI_SERVICE_NAME = "スクールAI";
export const SUCCEED_SERVICE_NAME = "サクシードAI";
export const SCHOOL_AI_STUDENT_LOGIN_PATH = "/login_for_student";
export const SUCCEED_STUDENT_LOGIN_PATH = "/login_for_student_succeed";

const SUCCEED_LOGIN_SCHOOL_DOC_IDS_BY_ENV: Record<
  SucceedLoginEnvironment,
  string[]
> = {
  dev: ["1lQUmn3HWmGZpKxrTEWM"],
  stg: ["W9BMRaucajt9URTeuzPf"],
  prod: ["g3y8P4lHBuWLloV4m16e", "RggN2gtYCePv4rajdYlm"]
};

function getSucceedLoginEnvironment(): SucceedLoginEnvironment {
  if (isProd) return "prod";
  if (isStg) return "stg";
  return "dev";
}

export function isSucceedLoginSchoolDocId(
  schoolDocId?: string | null
): boolean {
  const normalizedSchoolDocId = schoolDocId?.trim() ?? "";
  if (!normalizedSchoolDocId) return false;

  return SUCCEED_LOGIN_SCHOOL_DOC_IDS_BY_ENV[
    getSucceedLoginEnvironment()
  ].includes(normalizedSchoolDocId);
}

export function getSchoolAiServiceName(schoolDocId?: string | null): string {
  return isSucceedLoginSchoolDocId(schoolDocId)
    ? SUCCEED_SERVICE_NAME
    : DEFAULT_SCHOOL_AI_SERVICE_NAME;
}

export function getStudentLoginPath(schoolDocId?: string | null): string {
  return isSucceedLoginSchoolDocId(schoolDocId)
    ? SUCCEED_STUDENT_LOGIN_PATH
    : SCHOOL_AI_STUDENT_LOGIN_PATH;
}
